<template>
  <div>
    <table class="custom-table responsive-table border-collapse">
      <thead class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <th v-for="header in activeHeaders" :key="header.name">{{ header.name }}</th>
          <th tabindex="-1">
            <span @click="showFilterModal = true" class="cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(booking, index) in bookings" :key="index" class="shadow-table rounded-lg">
          <td>
            <base-checkbox />
          </td>

          <td v-for="header in activeHeaders" :key="header.name + 'tab'">
            <!-- Special case for Order Date -->
            <span v-if="header.name === 'Order Date'">
              {{ booking.createdAt ? booking.createdAt.split("T")[0] : "N/A" }}
              <span class="block w-full opacity-50">{{
                booking.createdAt
                  ? _addoneHourToTime(booking.createdAt)
                  : ""
              }}
              </span>
            </span>

            <!-- Special case for RECEIVER (merge name and phone) -->
            <span v-else-if="header.name === 'receiver address'">
              {{ booking.consigneelocation.address.name || 'N/A' }}
            </span>

            <!-- Special case for Sender (merge name and phone) -->
            <span v-if="header.name === 'sender address'">
              {{ booking.shipperlocation.address.name || 'N/A' }}
            </span>

            <!-- Special case for 3PL -->
            <span v-else-if="header.name === '3PL'" v-html="organizationName(booking)">
            </span>
            <!-- <span v-else-if=" header.name === '3PL'">
              {{ organizationName(booking) }}
            </span> -->

            <!-- Special case for Consignee-->
            <span v-else-if="header.name === 'Consignee'">
              <!-- {{
              booking.consigneelocation
              ? booking.consigneelocation.contactName || "N/A"
              : "N/A"
              }} -->
              {{
                booking.shipmentReceiever[0] &&
                  booking.shipmentReceiever[0].location &&
                  booking.shipmentReceiever[0].location.contactName
                  ? booking.shipmentReceiever[0].location.contactName
                  : "N/A"
              }}
            </span>

            <!-- Special case for Total Shipping Cost-->
            <span v-else-if="header.name === 'Total Shipping Cost'">
              {{
                booking.transaction
                  ? `₦ ${amountFomatter(booking.transaction.totalValue)}`
                  : "N/A"
              }}
              <!-- {{
                booking.consigneelocation
                  ? booking.consigneelocation.contactName || "N/A"
                  : "N/A"
              }} -->
            </span>

            <!-- Special case for Order Status -->
            <span v-else-if="header.name === 'Order Status'">
              <span :class="[
                true ? statusBg(booking ? booking.deliveryStatus : null) : null,
              ]" class="capitalize">{{ booking ? (booking.deliveryStatus).replace("_", " ") : null }}</span>
            </span>

            <!-- Special case for Payment Status -->
            <span v-else-if="header.name === 'Payment Status'">
              <span :class="[
                true ? statusBg(booking ? booking.paymentStatus : null) : null,
              ]">{{ booking ? booking.paymentStatus : null }}</span>
            </span>

            <!-- Special case for Estimated delivery date -->
            <span v-else-if="header.name === 'Estimated delivery date'">
              {{ booking.deliveryDays ? booking.deliveryDays.split("T")[0] : "N/A" }}
            </span>

            <!-- Default case for other headers -->
            <span v-else>
              {{ getNestedValue(booking, headerMap[header.name]) }}
            </span>
          </td>

          <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer relative">
            <span class="-full flex justify-center" @click="selectedRowId = index">
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == index">
              <div @click="transactionRoute(booking.transactionId)" class="cursor-pointer hover:bg-gray-100">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                <span>View</span>
              </div>
              <div @click="rating(booking, booking.id)" class="cursor-pointer hover:bg-gray-100">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/ondemand/rating-icon.svg" /></span>
                <span>Rate Now</span>
              </div>
              <div @click="claim(booking.transactionId)" class="cursor-pointer hover:bg-gray-100">
                <span class="icon"><img width="20" alt="" class="mr-1"
                    src="@/assets/images/ondemand/new-claim-icon.png" /></span>
                <span>Claims</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <EmptyContent v-if="(bookings || []).length < 1" />

    <BookingTableHeaderFilter :show-modal="showFilterModal" :activeHeaders="activeHeaders"
      @close-modal="showFilterModal = false" />


    <AcknowledgeRating :showModal="showSuccessModal" @close-modal="showSuccessModal = false" />
    <RatingModal @success="showSuccessModal = true" :showModal="showModal" @close-modal="showModal = false" />
  </div>
</template>

<script>
import AcknowledgeRating from "@/components/Ondemand/Bookings/modals/AcknowledgeRating.vue";
import RatingModal from "@/views/Ondemand/booking/RatingAction.vue"
import EmptyContent from "../UI/EmptyContent.vue";
import BookingTableHeaderFilter from "./modals/BookingTableHeaderFilter.vue";


export default {
  props: ["bookings"],
  components: {
    BookingTableHeaderFilter,
    AcknowledgeRating,
    RatingModal,
    EmptyContent,
  },
  data() {
    return {
      showSuccessModal: false,
      showModal: false,
      showFilterModal: false,
      collectPaymentModal: false,
      selectedRowId: -1,
      shareLinkModal: false,
      totalCost: 0,
      transactionId: null,
      shippingId: "",
      paylink: "",
      email: "",
      payAmount: "",
      activeHeaders: [
        { name: "Order Date" },
        { name: "Shipping ID #" },
        { name: "3PL" },
        { name: "Consignee" },
        { name: "Total Shipping Cost" },
        { name: "Order Status" },
        { name: "Payment Status" },
      ],
      headerMap: {
        'Order Date': '',
        'Shipping ID #': 'shippingReference',
        '3PL': '',
        'Consignee': '',
        'Total Shipping Cost': '',
        'Order Status': '',
        "Payment Status": '',
        "sender address": '',
        "receiver address": '',
        "Gross weight": 'grossWeight',
        "Estimated delivery date": ''
      },
    };
  },
  computed: {
    paymentParams() {
      return {
        paylink: this.paylink,
        email: this.email,
        payAmount: this.payAmount,
      };
    },
  },
  methods: {
    getNestedValue(obj, path) {
      const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
      return value === null || value === undefined || value === '' ? '' : value;
      // return value === null || value === undefined || value === '' ? 'N/A' : value;
    },

    // organizationName(org){
    //    const orgName = org?.shippingservice?.orgName
    //    const dispatcherOrg = (org.driver || {}).company_name
    //    if(orgName && orgName !== 'null') return orgName 
    //    if(dispatcherOrg) return dispatcherOrg

    //    return 'N/A'
    // },
    organizationName(org) {

      const orgName = org?.shippingservice?.orgName ?? 'N/A';
      const driver = org.driver;
      if (orgName && orgName !== 'null') return orgName

      if (driver) {
        const driverName = `${driver.first_name} ${driver.last_name}`;
        const dispatcherOrg = driver.company_name
        return `${dispatcherOrg}<br> ${driverName}`;
      }

      return 'N/A'
    },

    collectPaymentModalFunc(val) {
      this.totalCost = val?.transaction?.totalValue;
      this.transactionId = val?.transaction?.id;
      this.shippingId = val?.id;
      this.collectPaymentModal = true;
    },
    transactionRoute(val) {
      if (!val) return;
      localStorage.setItem("billing_reciept", "recievable");
      this.$router.push({ name: "BCM_reciept", params: { id: val } });
    },
    claim(val) {
      if (!val) {
        return;
      }
      this.$router.push({ name: "BookingFlowClaim", params: { id: val } });
    },
    rating(booking, val) {
      if (!val) {
        this.generateToast("No transaction available", "error");
        return;
      }
      this.$store.dispatch('setRatingsBooking', booking);
      this.showModal = true;
    },
    sharelinkModalFunc(val) {
      this.payAmount = val?.transaction?.totalValue;
      this.email = val?.transaction?.id;
      this.paylink = val?.id;
      this.shareLinkModal = true;
    },
    statusBg(val) {
      let bg = "";
      switch (val) {
        case "cancelled":
          bg = "text-red-500";
          break;
        case "not paid":
          bg = "text-red-500";
          break;
        case "draft":
          bg = "text-red-500";
          break;
        case "delivered":
          bg = "text-teal-500";
          break;
        case "estimate":
          bg = "text-primary-yellow";
          break;

        default:
          bg = "text-teal-500";
          break;
      }
      return bg;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
  min-width: 200px;
}

.actions div {
  @apply flex w-full py-2 px-2 items-center;
}

.icon {
  width: auto;
  padding-right: 5px;
}

// .svg-container {
//   background-color: #878E99; 
//   display: inline-block; /* Keeps the size to the content */
//   padding: 3px; 
//   border-radius: 50%; 
// }</style>
